/**
 * @generated SignedSource<<601009df55d596b263617225409f82d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PromotionCopyInput = {
  promotionId: string;
};
export type PromotionActionsMutationButtonStack_promotionCopyMutation$variables = {
  input: PromotionCopyInput;
};
export type PromotionActionsMutationButtonStack_promotionCopyMutation$data = {
  readonly promotionCopy: {
    readonly id: string;
  };
};
export type PromotionActionsMutationButtonStack_promotionCopyMutation = {
  response: PromotionActionsMutationButtonStack_promotionCopyMutation$data;
  variables: PromotionActionsMutationButtonStack_promotionCopyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Promotion",
    "kind": "LinkedField",
    "name": "promotionCopy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionActionsMutationButtonStack_promotionCopyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromotionActionsMutationButtonStack_promotionCopyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d1ce042c013f2635470d28dba69a4d40",
    "id": null,
    "metadata": {},
    "name": "PromotionActionsMutationButtonStack_promotionCopyMutation",
    "operationKind": "mutation",
    "text": "mutation PromotionActionsMutationButtonStack_promotionCopyMutation(\n  $input: PromotionCopyInput!\n) {\n  promotionCopy(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ffd7e9daa0a853cf27856c9d5543cc43";

export default node;
